import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/patientIndicatorNames',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/patientIndicatorNames/inventory',
      method: 'get',
      params
    })
  }
  
export function show(id) {
    return request({
      url: `/patientIndicatorNames/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/patientIndicatorNames',
      method: 'post',
      data
    })
  }
 

  export function update(data) {
    return request({
      url: `/patientIndicatorNames/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/patientIndicatorNames/${id}`,
      method: 'delete',
    })
  }
